import { render, staticRenderFns } from "./DepositKhazna.vue?vue&type=template&id=2676ebb8"
import script from "./DepositKhazna.vue?vue&type=script&lang=js"
export * from "./DepositKhazna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports